<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="col-sm-12 text-left">
      <h3>
        <router-link to="/clientes/cob">Cobrança</router-link> | 
        <router-link to="/clientes/sup">Suporte</router-link>
        <button @click.prevent="addNew()" class="btn btn-success pull-right">Novo Cliente</button>
      </h3>
      <small>{{clientes.length}} resultado(s) encontrados</small>
      <small v-if="this.$route.query.s"> que contém '{{this.$route.query.s}}'</small>
    </div>
    <table>
      <tr>
        <td></td>
        <td class="lt500">cnpj</td>
        <td>razao</td>
        <td>cidade</td>
        <td class="lt500">chave</td>
        <td class="lt500">uso</td>
        <td class="lt500">dia</td>
        <td class="lt500">valor</td>
        <td>contato</td>
      </tr>
      <tr v-for="cliente in clientes" :class="cliente.situacao==='2'? 'text-danger bg-danger' : ''">
        <td class="nowrap">
          <a @click.prevent="select4edit(cliente.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a>
          <a @click.prevent="select4agenda(cliente.cod)" class="glyphicon glyphicon-book" title="Agenda"></a>
          <a v-if="cliente.grupo" @click.prevent="select4grupo(cliente.grupo)"class="glyphicon glyphicon-th-large" :title="cliente.grupo"></a>
        </td>
        <td class="lt500">{{maskCnpj(cliente.cnpj)}}</td>
        <td>
          {{cliente.razao}}<br>
          <small>{{cliente.fantasia}}</small>
          <b v-if="cliente.situacao==='2'" class="bg-danger text-danger"><i class="glyphicon glyphicon-lock"></i>Bloqueado. Não Atender!</b>
          <b v-if="cliente.situacao==='0'" class="bg-warning text-danger"><i class="glyphicon glyphicon-delete"></i>Ex Cliente. Não Atender!</b>
        </td>
        <td>{{cliente.endcidade !== '' ? cliente.endcidade : cliente.cobcidade}}</td>
        <td class="lt500">{{ cliente.chavecliente }}</td>
        <td class="lt500">
          <div v-if="cliente.certificado!=='A1'" class="label label-danger">{{cliente.certificado}}</div>
          <div v-if="cliente.uso==='linux'" class="label label-success">Linux</div>
          <div v-if="cliente.situacao==='3'" class="label label-warning">Antigo</div>
          <div v-if="cliente.unfe!=='0'" v-html="useIt(cliente.unfe)" class="use"></div>
          <div v-if="cliente.ucfe!=='0'" v-html="useIt(cliente.ucfe)" class="use"></div>
          <div v-if="cliente.unfse!=='0'" v-html="useIt(cliente.unfse)" class="use"></div>
          <div v-if="cliente.umdfe!=='0'" v-html="useIt(cliente.umdfe)" class="use"></div>
          <div v-if="cliente.ucte!=='0'" v-html="useIt(cliente.ucte)" class="use"></div>
          <div v-if="cliente.uetiq!=='0'" v-html="useIt(cliente.uetiq)" class="use"></div>
        </td>
        <td class="lt500">{{cliente.cobdia}}</td>
        <td class="lt500">{{maskMonetario(cliente.cobvalor, true)}}</td>
        <td>
            <span v-for="telefone in cliente.telefone" class="nowrap">{{maskTelefone(telefone.numero)}}</br></span>
        </td>
      </tr>
    </table>
    <br><br><br>
  </div>
</template>

<script>
  import Mask from './Mask.js'
  export default {
    name: 'datalist',
    data () {
      return {
        loading: false,
        clientes: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getcliente.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            // console.log(response.body)
            if (response.body.length > 0) {
              this.clientes = response.body
            } else {
              this.clientes = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      addNew () {
        this.$router.push({path: '/cliente/0'})
      },
      select4edit (cod) {
        this.$router.push({path: `/cliente/${cod}`})
      },
      select4agenda (cod) {
        this.$router.push({path: `/agenda/c/${cod}`})
      },
      select4grupo (grupo) {
        this.$router.push({path: `/clientes/cob/${grupo}`})
      },
      useIt (input) {
        if (input !== '0') {
          let classe = 'label label-primary'
          if (input[0] === '-') {
            classe = 'label label-danger'
          }
          return `<span class='${classe}'>${input}</span>`
        }
      }
    },
    created: function () {
      this.maskCnpj = Mask.cnpj
      this.maskMonetario = Mask.monetario
      this.maskTelefone = Mask.telefone
      const keyword = this.$route.query.s
      this.load({'cob': true, 'keyword': keyword})
    },
    watch: {
      '$route' (to, from) {
        const keyword = this.$route.query.s
        this.load({'cob': true, 'keyword': keyword})
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
    }
    table tr:not(.text-danger):not(:first-child) {
      background: #fcfcfc;
    }
    table tr:not(.bg-danger):not(:first-child):nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none;
    }
    .nowrap {
      white-space: nowrap;
    }
    @media (max-width: 499px) {
      .container-fluid {
        width: 100vw;
        margin: 0;
        padding: 0;
      }
      table {
        font: 10px sans-serif;
        width: 100vw;
      }
      .lt500 {
        display: none;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/CliRelCob.vue